import { createDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
const ITerminalService = ( createDecorator('terminalService'));
const ITerminalEditorService = ( createDecorator('terminalEditorService'));
const ITerminalGroupService = ( createDecorator('terminalGroupService'));
const ITerminalInstanceService = ( createDecorator('terminalInstanceService'));
const isDetachedTerminalInstance = (t) => typeof t.instanceId !== 'number';
class TerminalLinkQuickPickEvent extends MouseEvent {
}
const terminalEditorId = 'terminalEditor';
export { ITerminalEditorService, ITerminalGroupService, ITerminalInstanceService, ITerminalService, TerminalLinkQuickPickEvent, isDetachedTerminalInstance, terminalEditorId };
